import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs';
import { Credentials } from '../../domain/credentials';
import { AppConfigService } from '../app-config-service/app-config.service';
import { LoggingService } from '../logging-service/logging.service';
import { Subscription } from 'rxjs/Subscription';


////-------------------------------------------------------------------------------------------
// Author:      Martin Unger
// Created:     05/12/2017
// Description: Deals with wrapping http post requests in order to attach the authorisation token
//              to each request
//----------------------------------------------------------------------------------------------

@Injectable()
export class AuthHttpClient {

  private getSubscription: Subscription;
  private postSubscription: Subscription;

  // Store the credentials of the user from the login form
  public Credentials?: Credentials;

  // DI
  constructor(private http: Http, private appConfigService: AppConfigService, private loggingService: LoggingService) {
  }

  getHeaders(): any {

    const bearerToken = sessionStorage.getItem('BearerToken');
    if (bearerToken != null) {
      return { Authorization: `Bearer ${bearerToken}` }
    }
    return null;

  }

  token(): string {
    return sessionStorage.getItem('BearerToken');
  }

  // Creates the appropriate authorisation header
  private createAuthorizationHeader(headers: Headers) {
    this.loggingService.log('Creating authorisation header', this.appConfigService.LogToConsole);

    // Log in using basic authentication
    if (this.Credentials !== undefined && this.Credentials !== null) {
      sessionStorage.removeItem('BearerToken');
      headers.append('x-wellbeing-ux', 'true');
      headers.append('Authorization', 'Basic ' +
        btoa(this.Credentials.Username + ':' + this.Credentials.Password));
      this.Credentials = null;
      return;
    }

    // No credentials. Try getting a token.
    this.appendToken(headers);
  }

  // Appends a token to a a header
  private appendToken(headers: Headers) {
    this.loggingService.log('Appending token', this.appConfigService.LogToConsole);

    const bearerToken = sessionStorage.getItem('BearerToken');
    if (bearerToken != null) {
      headers.append('Authorization', 'Bearer ' +
        bearerToken);
    }
  }

  // Creates the logout headers 
  private createLogoutHeader(headers: Headers) {
    this.loggingService.log('Creating logout header', this.appConfigService.LogToConsole);

    this.appendToken(headers);
    headers.append('x-logout', 'true');
  }

  // Gets a url using http get
  public get(url) {

    if (this.urlInvalid(url)) {
      return;
    }

    this.loggingService.log('Performing get request', this.appConfigService.LogToConsole);

    const headers = new Headers();
    this.createAuthorizationHeader(headers);

    return this.http.get(url, {
      headers: headers
    })

  }

  // Gets a url using http post
  public post(url, data) {

    if (this.urlInvalid(url)) {
      return;
    }

    this.loggingService.log('Performing post request', this.appConfigService.LogToConsole);

    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    this.createAuthorizationHeader(headers);
    return this.http.post(url, data, {
      headers: headers
    });
  }

  // Sends a logout request with x-logout
  public postLogout(url) {

    if (this.urlInvalid(url)) {
      return;
    }

    this.loggingService.log('Performing post to log out', this.appConfigService.LogToConsole);

    const headers = new Headers();
    this.createLogoutHeader(headers);
    return this.http.post(url, null, {
      headers: headers
    });
  }

  // Saves a token to local storage
  public saveToken(response: Response) {
    this.loggingService.log('Saving token', this.appConfigService.LogToConsole);
    sessionStorage.setItem('BearerToken', response.headers.get('bearer'));
  }

  // Removes a token from local storage
  public deleteToken() {
    this.loggingService.log('Deleting token', this.appConfigService.LogToConsole)
    sessionStorage.removeItem('BearerToken');
  }

  private urlInvalid(url: string): boolean {
    if (!url) {
      return !url;
    }

    return !url.trim();
  }

}




// WEBPACK FOOTER //
// ./src/app/services/auth-http-service/auth-http.service.ts